import React, { useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	Button,

} from '@chakra-ui/react'
import { InputText, Form } from '../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../helpers';

function Edit({ meCloseEdit, rs, loadList, customer_id }) {



	const [formData, setFormData] = useState({
		username: rs.username,
		email: rs.email,
		customer_id: rs.customer_id,
		id: rs.id

	});

	const FormSchema = Yup.object().shape({
		username: Yup.string().required('Required'),
		email: Yup.string()
			.email('Invalid email address')
			.required('Email is required'),




	});








	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		let data = values


		const url = `${process.env.REACT_APP_API_URL}/user/update`;
		await fetchWrapper.post(url, data)
		loadList()
		meCloseEdit();
		toast(`Record has been updated `, {
			type: "info"
		});
	}

	return (


		<Form
			enableReinitialize
			validationSchema={FormSchema}
			initialValues={formData}
			onSubmit={onSubmit}
		>

			<Box mb="10px">
				<InputText name="username" title="Full Name" />
			</Box>
			<Box mb="10px">
				<InputText name="email" title="Email " />
			</Box>






			<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
				mb={4}

				type='submit'
			>
				Update User
			</Button>
		</Form>


	)
}

export default Edit;